import React from 'react';

/**
 * Template 3: Face + Card/Board
 * Person on left (30-40%), whiteboard/card on right with title + numbered list.
 *
 * Inspired by: "Book Funnel Masterclass", "BUYER SPECTRUM"
 */
export default function JH_FaceWithCard({
  headline = 'MASTERCLASS',
  personImage,
  bgColor = '#2D3748',
  accentColor = '#E53935',
  cardTitle = 'Book Funnel Masterclass',
  cardItems = ['Write the book', 'Build the funnel', 'Run paid ads', '$$$'],
}) {
  const isLightBg = isLightColor(bgColor);

  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Inter', sans-serif",
    }}>
      {/* Person image - left side */}
      {personImage ? (
        <div style={{
          position: 'absolute', left: 0, bottom: 0, width: 500, height: 720, zIndex: 2,
        }}>
          <img src={personImage} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center' }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', left: 30, bottom: 0, width: 420, height: 640,
          background: 'rgba(255,255,255,0.06)', borderRadius: '12px 12px 0 0',
          zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 36, color: 'rgba(255,255,255,0.15)',
        }}>PHOTO</div>
      )}

      {/* Whiteboard / Card - right side */}
      <div style={{
        position: 'absolute', right: 50, top: 50, width: 660, height: 620,
        background: '#FFFFFF', borderRadius: 16,
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        zIndex: 1, padding: '36px 40px',
      }}>
        {/* Card title with underline */}
        <div style={{
          fontSize: 36, fontWeight: 800, color: '#111',
          marginBottom: 8, fontFamily: "'Inter', sans-serif",
        }}>
          {cardTitle}
        </div>
        <div style={{
          width: 80, height: 4, background: accentColor, marginBottom: 32, borderRadius: 2,
        }} />

        {/* Numbered items */}
        {cardItems.map((item, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 16,
            marginBottom: 28,
          }}>
            <span style={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              width: 48, height: 48, borderRadius: '50%',
              border: `3px solid ${accentColor}`, color: accentColor,
              fontSize: 24, fontWeight: 800, flexShrink: 0,
            }}>{i + 1}</span>
            <span style={{
              fontSize: 28, fontWeight: 600, color: '#222',
            }}>{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function isLightColor(color) {
  const hex = (color || '#000').replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const toL = c => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  return 0.2126 * toL(r) + 0.7152 * toL(g) + 0.0722 * toL(b) > 0.35;
}
